import apiFetch from "../utils/fetch";


export function userCreate(data, idToken, callback, errorcallback) {

}

export function userEdit(data, callback, errorcallback) {
    apiFetch('/api/user/edit/' + data._id, {
        method: 'PUT',
        body: JSON.stringify(data),
    }).then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}

export function userGetByEmail(username, callback, errorcallback) {
    apiFetch('/api/user/email/' + username).then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}